import {FieldWrapper, getFieldState, IFieldWrapperProps} from "@pg-design/inputs-module";
import {InputWrapper} from "@pg-design/inputs-module";
import {getErrorMessage} from "@pg-design/inputs-module/src/utils/get_error_message";
import {ISelectProps, Select} from "@pg-design/select-module";

export type ISelectFieldProps = IFieldWrapperProps &
    ISelectProps & {
        error?: string | string[];
    };

export const SelectField = (props: ISelectFieldProps) => {
    const {labelContent, message, id, className, error, dataTestId, ...selectProps} = props;

    const fieldState = getFieldState(props);
    const errorMessage = getErrorMessage(props.error);

    return (
        <FieldWrapper
            labelContent={labelContent}
            fieldState={fieldState}
            message={errorMessage || message}
            htmlFor={id}
            className={className}
            dataTestId={dataTestId}
        >
            <InputWrapper fieldState={!!error ? "error" : "default"} noPadding>
                <Select {...selectProps} isBorderless />
            </InputWrapper>
        </FieldWrapper>
    );
};
import {FieldWrapper, getFieldState, IFieldWrapperProps} from "@pg-design/inputs-module";
import {InputWrapper} from "@pg-design/inputs-module";
import {getErrorMessage} from "@pg-design/inputs-module/src/utils/get_error_message";
import {ISelectProps, Select} from "@pg-design/select-module";

export type ISelectFieldProps = IFieldWrapperProps &
    ISelectProps & {
        error?: string | string[];
    };

export const SelectField = (props: ISelectFieldProps) => {
    const {labelContent, message, id, className, error, dataTestId, ...selectProps} = props;

    const fieldState = getFieldState(props);
    const errorMessage = getErrorMessage(props.error);

    return (
        <FieldWrapper
            labelContent={labelContent}
            fieldState={fieldState}
            message={errorMessage || message}
            htmlFor={id}
            className={className}
            dataTestId={dataTestId}
        >
            <InputWrapper fieldState={!!error ? "error" : "default"} noPadding>
                <Select {...selectProps} isBorderless />
            </InputWrapper>
        </FieldWrapper>
    );
};
